<h2 mat-dialog-title>{{ headerText() }}</h2>
<mat-dialog-content>
  <span class="name">{{ data.name }}</span> {{ data.afterNameText }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="abort()" cdkFocusInitial>Nein</button>
  <button mat-raised-button (click)="confirm()">Ja</button>
</mat-dialog-actions>